module.exports = __webpack_public_path__ + "img/Banco-Falabella.01300f07.svg";